import { render, staticRenderFns } from "./RankLongevityDetails.vue?vue&type=template&id=cdd39cc6"
import script from "./RankLongevityDetails.vue?vue&type=script&lang=js"
export * from "./RankLongevityDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports